export class NotificationDataHelper {
  productionNotification: string;

  constructor(productionNotification: string) {
    this.productionNotification =
      // tslint:disable-next-line: no-null-keyword
      productionNotification === undefined ? null : productionNotification;
  }
}
